import { Box } from "@mui/material";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import ChatScreen from "./ui/ChatScreen";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

/**
 * Chat shell: same content rhythm as other dashboard pages.
 */
const Report = () => {
  const custom = useAppCustomStyles();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <Box sx={custom.pages.report.chatShell}>
          <ChatScreen />
        </Box>
      </PageContentShell>
    </DashboardLayout>
  );
};

export default Report;
